<template>
  <div class="full-text-url-provider">
    <slot v-if="!hasError" v-bind="{ url }"></slot>
    <slot v-else name="error" v-bind="{ error }">
      <page-content-placeholder
        icon="sentiment_very_dissatisfied"
        prompt-text="Something went wrong"
      >
        <template #message>
          An error occured while fetching the PDF, try refreshing the
          page.
        </template>
      </page-content-placeholder>
    </slot>
  </div>
</template>

<script>
import PageContentPlaceholder from '@/components/Common/PageContentPlaceholder';
import { mapActions } from 'vuex';

export default {
  name: 'FullTextUrlProvider',
  components: { PageContentPlaceholder },
  props: {
    referenceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      url: null,
      error: null,
    };
  },
  computed: {
    hasError() {
      return !!this.error;
    },
  },
  watch: {
    referenceId() {
      this.fetchPdfUrl();
    },
  },
  mounted() {
    this.fetchPdfUrl();
  },
  methods: {
    ...mapActions({
      fetchDownloadUrl: 'fullTextPdf/fetchDownloadUrl',
      deletePdf: 'fullTextPdf/delete',
    }),
    async fetchPdfUrl() {
      this.url = null;
      try {
        this.url = await this.fetchDownloadUrl({
          referenceId: this.referenceId,
        });
      } catch (e) {
        const graphqlErrors = e.graphQLErrors;
        if (
          graphqlErrors.some(
            (error) =>
              error.extensions.type === 'FullTextPDFNotFoundException'
          )
        ) {
          // PDF Is missing get them to upload it again.
          this.deletePdf(this.referenceId);
        } else {
          this.error = e;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-text-url-provider {
  width: 100%;
  height: 100%;
}
</style>
